import { render } from "./CustomSelect.vue?vue&type=template&id=33d92799"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/double-daywrap-newsystem-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__